import _ from 'underscore';

function patchColumns(columns) {
  return _.map(columns, column => _.defaults({
    headAttributes: _.extend({
      'aria-label': column.title || column.name,
    }, column.headAttributes),
  }, column));
}


function a11yHandler(state) {
  const config = ((this.get('plugins') || {}).a11y) || {};

  const allyBodyRows = {
    length: state.bodyRows.length,
    slice: (begin = 0, end = state.bodyRows.length) => state.bodyRows
      .slice(begin, end)
      .map((row) => {
        const isSelected = row.classes && row.classes.includes('row-selected');
        const allyAttributes = isSelected ?
          _.defaults({
            tabindex: 0,
            role: 'row',
            'aria-selected': 'true',
          }, row.attributes) :
          row.attributes;

        return _.defaults({ attributes: allyAttributes }, row);
      }),
  };
  return _.defaults({
    columns: patchColumns(state.columns),
    bodyRows: config.allyBodyRows ? allyBodyRows : state.bodyRows,
    events: _.defaults({
      'click th.column-header-sortable[data-name]': function handleHeaderClick(event) {
        const name = this.$(event.target).closest('th').attr('data-name');

        this.once('didUpdate', () => _.defer(() => {
          const el = this.$(`th[data-name="${name}"]`).get(0);

          if (el) {
            el.focus();
          }
        }));
      },
      'click div[role="columnheader"].column-header-sortable[data-name]': function handleFlexLayoutGridHeaderClick(event) {
        const name = this.$(event.target).closest('div[role="columnheader"]').attr('data-name');

        this.once('didUpdate', () => _.defer(() => {
          const el = this.$(`div[role="columnheader"][data-name="${name}"]`).get(0);

          if (el) {
            el.focus();
          }
        }));
      },
    }, state.events),
  }, state);
}

export const a11yProjection = {
  name: 'a11y',
  handler: a11yHandler,
};
